import type { Video } from "@/types/content";

export const videos: Video[] = [
  {
    id: "street-interview-content",
    title: "街头采访：年轻人眼里的「好内容」到底是什么",
    category: "opinion",
    tags: ["街头采访", "内容消费", "年轻人"],
    author: { name: "抖阳视频组", role: "原创视频", bio: "用镜头记录城市里的真实表达。" },
    date: "2026-10-15",
    duration: "08:42",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20street%20interview%20scene%20with%20a%20young%20person%20holding%20a%20microphone%20in%20a%20busy%20city%20alley%2C%20warm%20late%20afternoon%20light%2C%20cream%20and%20terracotta%20tones%2C%20cinematic%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=dy-v-street-cover&orientation=landscape",
    summary:
      "我们在三个城市问了同一个问题：你上一次认真看完一条内容是多久以前？答案比想象中复杂。",
    views: 84210,
    featured: true,
  },
  {
    id: "clay-teapot-craft",
    title: "手作纪录：一把陶壶的七十二道工序",
    category: "culture",
    tags: ["手作", "陶艺", "纪录片"],
    author: { name: "沈禾", role: "特约作者", bio: "长期走访手工艺现场，关注技艺传承中的身体经验。" },
    date: "2026-10-12",
    duration: "12:08",
    cover:
      "https://readdy.ai/api/search-image?query=Artisan%20hands%20shaping%20a%20clay%20teapot%20on%20a%20potter%20wheel%2C%20wet%20clay%20texture%2C%20warm%20workshop%20light%2C%20earthy%20cream%20and%20rust%20tones%2C%20macro%20documentary%20craft%20photography&width=1200&height=800&seq=dy-v-teapot-cover&orientation=landscape",
    summary: "从练泥到烧成，一把壶要经过七十二道工序。我们记录了其中的十四天。",
    views: 46320,
    featured: true,
  },
  {
    id: "old-street-24h",
    title: "镜头里的老街：一条街的二十四小时",
    category: "life",
    tags: ["城市", "街区", "纪实"],
    author: { name: "抖阳视频组", role: "原创视频", bio: "用镜头记录城市里的真实表达。" },
    date: "2026-10-08",
    duration: "15:36",
    cover:
      "https://readdy.ai/api/search-image?query=Early%20morning%20on%20an%20old%20Chinese%20street%20with%20steam%20rising%20from%20breakfast%20stalls%2C%20warm%20lantern%20light%2C%20cream%20and%20amber%20color%20palette%2C%20cinematic%20documentary%20photography%2C%20soft%20haze&width=1200&height=800&seq=dy-v-oldstreet-cover&orientation=landscape",
    summary: "凌晨四点的豆浆摊，下午三点的修表匠，晚上十一点的最后一盏灯。",
    views: 62540,
  },
  {
    id: "short-drama-set-tour",
    title: "短剧片场探班：三小时拍完一集是真的吗",
    category: "entertainment",
    tags: ["短剧", "片场", "幕后"],
    author: { name: "周映", role: "娱乐记者", bio: "跟踪影视工业化与新兴内容形态，采访过两百余位剧组从业者。" },
    date: "2026-10-04",
    duration: "09:55",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20compact%20film%20set%20with%20a%20camera%20operator%20and%20lighting%20stands%2C%20warm%20studio%20light%2C%20dark%20curtains%2C%20cinematic%20documentary%20photography%2C%20terracotta%20accents&width=1200&height=800&seq=dy-v-settour-cover&orientation=landscape",
    summary: "我们跟着一个剧组拍了整整一天，算了一笔关于时间的账。",
    views: 38710,
  },
  {
    id: "midnight-kitchen",
    title: "一个人的深夜食堂：营业到凌晨两点的十二平米",
    category: "life",
    tags: ["深夜食堂", "城市", "人物"],
    author: { name: "苏晚", role: "生活方式编辑", bio: "写城市生活实验与消费观察。" },
    date: "2026-09-30",
    duration: "10:24",
    cover:
      "https://readdy.ai/api/search-image?query=Tiny%20late%20night%20noodle%20shop%20with%20warm%20hanging%20lights%2C%20a%20cook%20behind%20the%20counter%2C%20empty%20stools%2C%20steam%20and%20amber%20glow%2C%20cream%20and%20terracotta%20tones%2C%20cinematic%20documentary%20photography&width=1200&height=800&seq=dy-v-midnight-cover&orientation=landscape",
    summary: "老板说，来这里的客人只有两种：加班的，和不想回家的。",
    views: 55380,
  },
  {
    id: "livehouse-night",
    title: "独立音乐现场：livehouse 的一夜",
    category: "entertainment",
    tags: ["音乐现场", "独立音乐", "夜生活"],
    author: { name: "抖阳视频组", role: "原创视频", bio: "用镜头记录城市里的真实表达。" },
    date: "2026-09-26",
    duration: "13:17",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20livehouse%20concert%20with%20a%20band%20silhouetted%20against%20warm%20red%20stage%20lights%2C%20crowd%20raising%20hands%2C%20hazy%20atmosphere%2C%20cinematic%20concert%20photography%2C%20deep%20amber%20tones&width=1200&height=800&seq=dy-v-livehouse-cover&orientation=landscape",
    summary: "一个两百人的场地，一支刚发片的乐队，和一群愿意站三个小时的人。",
    views: 41260,
  },
];